import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/window-restore': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M464 0c26.5 0 48 21.5 48 48v320c0 26.5-21.5 48-48 48h-48v48c0 26.5-21.5 48-48 48h-320c-26.5 0-48-21.5-48-48v-320c0-26.5 21.5-48 48-48h48v-48c0-26.5 21.5-48 48-48h320zM368 464v-208h-320v208h320zM464 368v-320h-320v48h224c26.5 0 48 21.5 48 48v224h48z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/window-restore.js
// module id = 1834
// module chunks = 0